  
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommandesService, CommandeListItem } from '../../../services/commandes.service';
import { PageEvent } from '@angular/material/paginator';
import { MatPaginatorModule } from '@angular/material/paginator';
import { FormsModule } from '@angular/forms';
import { RouterModule, Router } from '@angular/router';

@Component({
  selector: 'app-commandes-list',
  templateUrl: './commandes-list.component.html',
  styleUrls: ['./commandes-list.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    RouterModule,
    MatPaginatorModule,
  ]
})
export class CommandesListComponent implements OnInit {
  commandes: CommandeListItem[] = [];
  total = 0;
  pageSize = 20;
  pageIndex = 0;
  search = '';
  loading = false;
  error = '';
  constructor(
    private commandesService: CommandesService,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) {}


  editCommande(id: number) {
    this.router.navigate(['/intranet/commandes/modifier', id]);
  }

  ngOnInit() {
    this.loadCommandes();
  }

  loadCommandes() {
    this.loading = true;
    this.commandesService.listWithCount({ skip: this.pageIndex * this.pageSize, limit: this.pageSize, search: this.search })
      .subscribe(response => {
        this.commandes = response.items ?? [];
        this.total = response.count ?? 0;
        this.loading = false;
        this.cdr.detectChanges();
      });
  }

  deleteCommande(id: number) {
    if (confirm('Supprimer cette commande ?')) {
      this.commandesService.delete(id).subscribe({
        next: () => {
          this.error = '';
          this.loadCommandes();
        },
        error: (err) => {
          this.error = err?.error?.detail || err?.message || 'Erreur lors de la suppression de la commande.';
          this.cdr.detectChanges();
        }
      });
    }
  }

  onPage(event: PageEvent) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadCommandes();
  }

  onSearch() {
    this.pageIndex = 0;
    this.loadCommandes();
  }
}
